<script setup>
import { ref, onMounted, inject} from 'vue'
import { useConfirm } from "primevue/useconfirm";
const confirm = useConfirm();
import { useRouter } from 'vue-router'
const router = useRouter()
import { useWorkspaceStore } from '@stores/WorkspaceData';
const wpStore = useWorkspaceStore()
const toast = inject('toast')

const modellingStatus = ref(false)


const confirm2 = (event) => {
    confirm.require({
        target: event.currentTarget,
        message: 'Вы уверены что хотите выйти?',
        icon: 'pi pi-info-circle',
        rejectProps: {label: 'Отмена',severity: 'secondary',outlined: true},
        acceptProps: { label: 'Выйти',severity: 'danger'},
        accept: () => {
            mainService.logOut()
            router.push('/')
        },
    });
};
// Карта по умолчанию видна без открытого раздела и на «Горизонте моделирования»,
// на остальных разделах скрыта (включается кнопкой карты в меню)
const ChangeSelectComponent = (component) =>{
  if(wpStore.selectComponent == component){
    wpStore.selectComponent = ''
    wpStore.mapShow = true
    router.push('/main')
    return
  }
  wpStore.selectComponent = component
  wpStore.mapShow = component === 'time'
  router.push(`/main/${component}`)
}
function onThemeToggler() {
    const root = document.getElementsByTagName('html')[0];
    root.classList.toggle('p-dark');
}

import { MainService } from '@services/process/Main/main.service';
const mainService = new MainService()

// Пока работаем с одним проектом — берём первый проект пользователя
onMounted(async () => {
  const wpList = mainService.getWpList() || []
  if(!wpList.length) return
  if(!await mainService.initGlobaldata(wpList[0].id)){
    toast.error('Не удалось загрузить проект')
  }
})
</script>

<template>
<div class="CardContainer">
  <Card class="CardMenu">
    <template #title>Развитие АКА</template>
    <template #content>
      <section>
        <section class="ButtonControlProject">
          <Button @click="toast.warn('Не готово')" icon="pi pi-times" severity="danger"  size="small" variant="outlined" :disabled="false"/><!--Сброс проекта-->
          <Button @click="toast.warn('Не готово')" icon="pi pi-download"  severity="success" variant="outlined" size="small"  :disabled="false"/><!--сохранить копию локально-->
          <Button @click="toast.warn('Не готово')" icon="pi pi-upload" severity="info" variant="outlined" size="small"  :disabled="false"/><!--загрузить проект-->
          <Button icon="pi pi-map" severity="help" :variant="wpStore.mapShow? '':'outlined'" size="small"  :disabled="false" @click="wpStore.mapShow = !wpStore.mapShow"/><!--Карта-->
        </section>
        <section class="MenuGroup">
          <div class="MenuGroupTitle">Входные данные</div>
          <section class="ButtonControlPages">
            <Button label="Горизонт моделирования" variant="text" :severity="wpStore.selectComponent=='time'? '':'secondary'" @click="ChangeSelectComponent('time')"/>
            <Button label="Космический аппарат" variant="text" :severity="wpStore.selectComponent=='sat'? '':'secondary'" @click="ChangeSelectComponent('sat')"/>
            <Button label="Полётное задание" variant="text" :severity="wpStore.selectComponent=='target'? '':'secondary'" @click="ChangeSelectComponent('target')"/>
          </section>
        </section>
        <section class="MenuGroup">
          <div class="MenuGroupTitle">Моделирование</div>
          <section class="ButtonControlPages">
            <Button label="Выходные данные моделирования" variant="text" :severity="wpStore.selectComponent=='modelling'? '':'secondary'" @click="ChangeSelectComponent('modelling')"/>
          </section>
        </section>
      </section>
      <section class="UserControl">
        <Button icon="pi pi-sun" severity="secondary"  size="small" @click="onThemeToggler()"/>
        <Button icon="pi pi-sign-out" variant="text" size="small" severity="danger" @click="confirm2"/>
      </section>
    </template>
  </Card>
</div>
</template>

<style>
.CardContainer{
  height: 100%;
  width: fit-content;
  min-width: fit-content;
}
.CardMenu.p-card{
  margin: 5px 0px 5px 5px;
  height: calc(100% - 10px);
  border: none;
  background: none;
  box-shadow: none;
  
}
.CardMenu .p-card-caption, .CardMenu .p-card-content{
  background: var(--p-card-background);
  box-shadow: var(--p-card-shadow);
  border-radius: var(--p-content-border-radius);
  border: 1px solid var(--p-content-border-color);
} 

.CardMenu .ButtonControlPages{
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}
.CardMenu .p-card-body{
  padding: 0px;
  height: 100%;
  max-width: 230px;
  gap: 5px;
}
.CardMenu .p-card-content{
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  display: flex;
}
.ButtonControlProject{
  padding: 5px 5px;
  display: flex;
  justify-content: space-between;
}
.ButtonControlPages .p-button-text{
  padding: 10px 5px 10px 2px;
  justify-content: space-between;
  margin: 0px 0px 5px 5px;
}
.MenuGroup{
  margin: 5px 5px 10px 5px;
  border: 1px solid var(--p-content-border-color);
  border-radius: var(--p-content-border-radius);
  overflow: hidden;
}
.MenuGroupTitle{
  padding: 6px 8px;
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--p-text-muted-color);
  background: var(--p-content-hover-background);
  border-bottom: 1px solid var(--p-content-border-color);
  text-align: left;
}
.MenuGroup .ButtonControlPages{
  padding-top: 5px;
}
.ButtonControlPages .p-button-text{
  text-align: left;
}
.UserControl{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 5px;
}
</style>
